module.exports = __webpack_public_path__ + "static/media/cube_highways_logo.c489fd9e.jpg";